module.exports = __webpack_public_path__ + "img/c00_buildingtechimprovedfletching_Normal_ua.5edbd7fb.webp";